export const SET_CART = 'SET_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const REMOVE_CART = 'REMOVE_CART';
